module.exports = __webpack_public_path__ + "static/media/dobbi-logo.d01e329c.svg";